import { chatFragment } from '../fragments';
import { makeRequest } from '../utils';

/**
 * @param {string} id
 * @param {Record} data
 * @param {string} data.isPaused
 */
export const updateChat = (id, data) =>
  makeRequest({
    operationName: 'UpdateChat',
    query: `
      mutation UpdateChat($id: String! $data: ChatUpdateInput!) {
        updateChat(id: $id, data: $data) {
          ...ChatFragment
        }
      }

      ${chatFragment}
    `,
    variables: { id, data },
  });

/**
 * @param {string} id
 */
export const deleteChat = (id, data) =>
  makeRequest({
    operationName: 'DeleteChat',
    query: `
      mutation DeleteChat($id: String!) {
        deleteChat(id: $id) {
          ...ChatFragment
        }
      }

      ${chatFragment}
    `,
    variables: { id },
  });
